<div class="row p-b-10">
	<div class="col-sm-8 col-sm-offset-2">
		<h4 class="page-title">{{TR "Impressum"}}</h4>
	</div>
</div>

<div class="row">
	<div class="col-sm-8 col-sm-offset-2">
		<div class="card-box clearfix">
			<div class="row">
				<div class="col-sm-8">
					{{> IMPRINT_CONTENT}}
				</div>
				<div class="col-sm-4">
					<img class="m-t-10" src="img/samson_ktelektronik.png" />
				</div>
			</div>
			<div class="row hidden-xs">
				<div class="col-sm-12">
					<hr>
					{{{COPYRIGHT}}}
				</div>
			</div>
		</div>
	</div>
</div>
<div class="row">
	<div class="col-sm-12 text-center">
		<a href="">{{TR "Zurück"}}</a>
	</div>
</div>
